import { openScheduleDemoModal } from '@mfl/schedule-demo-modal';
import { currentUser, getAccountBasicInfo } from '@mfl/platform-shell';

export async function openScheduleDemo(context: string) {
  const accountInfo = getAccountBasicInfo();

  return openScheduleDemoModal({
    context,
    data: {
      name: accountInfo.userName,
      email: accountInfo.userEmail,
      company: accountInfo.companyName,
      companySize: accountInfo.companySize,
      userCountry: accountInfo.userCountry,
      title: accountInfo.userTitle,
      userId: currentUser.userId,
      accountId: currentUser.accountId,
    },
    analytics: { from: 'platform' },
  });
}
